<!-- timer -->
<template>
  <div>
    <!-- times -->
    <div class="pay-time title" v-if="orderInfo.orderId==null">
      <button class="btn btn-disabled" style="width: 80%;" disabled>
        {{$t("main['生成中请稍候']")}}
        <span style="color:yellow;">{{payTimeInfo.timeDownNo}}</span>
      </button>
    </div>
    <div class="pay-time title" v-else>
      {{$t("main['剩余时间']")}}:&nbsp;
      <span style="color:blue;font-family:inter;color: rgb(25, 118, 210);font-weight: 700;">{{payTimeInfo.timePayoutMin}}:{{payTimeInfo.timePayoutSec}}</span>
    </div>
    <div class="pay-time title" v-if="orderInfo.ifDebug">
      <span style="color:red; font-size: 0.85em;">调试模式20秒倒计时</span>
    </div>

    <!-- 弹框-拉单失败 -->
    <div class="show-msg-modal" v-if="payTimeInfo.timeDownNo<=0">
      <div class="show-msg-modal-content">
        <div style="font-size:1em;">
          <b>{{$t("main['订单']")}}<span style="color:red;">{{$t("main['生成失败']")}}</span></b>
        </div>
        <div style="font-size:0.8em;padding-top:2em;padding-bottom:2em;">{{$t("main['生成失败Memo']")}}</div>
      </div>
    </div>

    <!-- 弹框-支付超时 -->
    <div class="show-msg-modal" v-if="payTimeInfo.timeLastSss<=0&&orderInfo.statePayd!=true&&orderInfo.csTimeoutClose==true">
      <div class="show-msg-modal-content">
        <div style="font-size:1em;">
          <b>{{$t("main['订单']")}}<span style="color:red;">{{$t("main['已超时']")}}</span></b>
        </div>
        <div style="font-size:0.8em;padding-top:2em;padding-bottom:2em;">{{$t("main['已超时Memo']")}}</div>
      </div>
    </div>

    <!-- 弹框-支付成功 -->
    <div class="show-msg-modal" v-if="orderInfo.statePayd==true">
      <div class="show-msg-modal-content">
        <div style="font-size:1em;">
          <b>{{$t("main['订单']")}}<span style="color:#4CAF50;">{{$t("main['已支付']")}}</span></b>
        </div>
        <div style="font-size:0.8em;padding-top:2em;padding-bottom:2em;">{{$t("main['已支付Memo']")}}</div>
      </div>
    </div>

  </div>
</template>

<script>
import "@/styles/show-msg.css"; //
export default {
  components: {},
  props: {
    orderInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    payTimeInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      showMsg1: true,
    };
  },
  computed: {},
  created() {},
  methods: {},
};
</script>

<style lang="scss">
</style>

<style lang="scss" scoped>
</style>
